import React, { useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAddBookMutation } from "../../features/api/apiSlice";

export default function Form() {
  const [addBook, { isLoading, isError }] = useAddBookMutation();
  const navigate = useNavigate();

  const nameRef = useRef();
  const authorRef = useRef();
  const thumbnailRef = useRef();
  const priceRef = useRef();
  const ratingRef = useRef();
  const featuredRef = useRef(false);

  const resetForm = () => {
    nameRef.current.value = "";
    authorRef.current.value = "";
    thumbnailRef.current.value = "";
    priceRef.current.value = "";
    ratingRef.current.value = "";
    featuredRef.current.checked = false;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const data = {
      name: nameRef.current.value,
      author: authorRef.current.value,
      thumbnail: thumbnailRef.current.value,
      price: Number(priceRef.current.value),
      rating: Number(ratingRef.current.value),
      featured: featuredRef.current.checked,
    };
    addBook(data);
    resetForm();
    navigate("/");
  };

  return (
    <form className="book-form" onSubmit={handleSubmit}>
      <div className="space-y-2">
        <label htmlFor="lws-bookName">Book Name</label>
        <input
          ref={nameRef}
          required
          className="text-input"
          type="text"
          id="lws-bookName"
          name="name"
        />
      </div>

      <div className="space-y-2">
        <label htmlFor="lws-author">Author</label>
        <input
          ref={authorRef}
          required
          className="text-input"
          type="text"
          id="lws-author"
          name="author"
        />
      </div>

      <div className="space-y-2">
        <label htmlFor="lws-thumbnail">Image Url</label>
        <input
          ref={thumbnailRef}
          required
          className="text-input"
          type="text"
          id="lws-thumbnail"
          name="thumbnail"
        />
      </div>

      <div className="grid grid-cols-2 gap-8 pb-4">
        <div className="space-y-2">
          <label htmlFor="lws-price">Price</label>
          <input
            ref={priceRef}
            required
            className="text-input"
            type="number"
            id="lws-price"
            name="price"
          />
        </div>

        <div className="space-y-2">
          <label htmlFor="lws-rating">Rating</label>
          <input
            ref={ratingRef}
            required
            className="text-input"
            type="number"
            id="lws-rating"
            name="rating"
            min="1"
            max="5"
          />
        </div>
      </div>

      <div className="flex items-center">
        <input
          ref={featuredRef}
          id="lws-featured"
          type="checkbox"
          name="featured"
          className="w-4 h-4"
        />
        <label htmlFor="lws-featured" className="ml-2 text-sm">
          This is a featured book
        </label>
      </div>

      <button
        type="submit"
        disabled={isLoading}
        className="submit"
        id="lws-submit"
      >
        Add Book
      </button>
      {!isLoading && isError && <div>There was an error occured!</div>}
    </form>
  );
}
